/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */
import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';

Swiper.use([Autoplay, FreeMode, Navigation]);

/**
 * Swiper controller.
 */
export default class extends Controller {
  static targets = ['next', 'prev'];

  static values = {
    options: Object,
  };

  /**
   * Swiper instance.
   *
   */
  swiper;

  /**
   * Init.
   */
  initialize() {
    const options = {
      slidesPerView: 'auto',
      navigation: {
        nextEl: this.hasNextTarget ? this.nextTarget : null,
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
      },
      ...this.optionsValue,
    };

    this.swiper = new Swiper(this.element, options);
  }

  /**
   * Mount.
   */
  connect() {
    this.swiper.enable();
  }

  /**
   * Destroy.
   */
  disconnect() {
    this.swiper.destroy(true);
    this.swiper = undefined;
  }
}
